// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Theme = require("../reason/common/Theme/Theme.bs.js");
let Utils = require("./Utils.bs.js");
let React = require("react");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let UseWindowSize = require("uikit/hooks/useWindowSize");

function getBreakpoint(px) {
  let match = Theme.Breakpoints.breakpoints;
  if (px >= match.xxl) {
    return "xxl";
  } else if (px >= match.xl) {
    return "xl";
  } else if (px >= match.lg) {
    return "lg";
  } else if (px >= match.md) {
    return "md";
  } else if (px >= match.sm) {
    return "sm";
  } else {
    return "xs";
  }
}

function useResponsive(xs, sm, md, lg, xl, xxl, param) {
  let windowSize = UseWindowSize.useWindowSize();
  let fallback = (opt, fallbackVal) => {
    if (opt !== undefined) {
      return opt;
    } else {
      return fallbackVal;
    }
  };
  let match = getBreakpoint(windowSize.width);
  return Stdlib_Option.getOr(match === "md" ? fallback(md, sm) : (
      match === "sm" ? sm : (
          match === "xl" ? fallback(fallback(fallback(xl, lg), md), sm) : (
              match === "xs" ? Primitive_option.some(xs) : (
                  match === "xxl" ? fallback(fallback(fallback(fallback(xxl, xl), lg), md), sm) : fallback(fallback(lg, md), sm)
                )
            )
        )
    ), xs);
}

function eventTypeToJs(event) {
  return event;
}

function useEventListenerOnDocument(useCaptureOpt, handler, event) {
  let useCapture = useCaptureOpt !== undefined ? useCaptureOpt : false;
  let savedHandler = React.useRef(undefined);
  React.useEffect(() => {
    Utils.React.setCurrentRef(savedHandler, handler);
  }, [handler]);
  React.useEffect(() => {
    let onEvent = event => {
      let handler = savedHandler.current;
      if (handler !== undefined) {
        return handler(event);
      }
    };
    if (useCapture) {
      document.addEventListener(event, onEvent, true);
    } else {
      document.addEventListener(event, onEvent);
    }
    return () => {
      document.removeEventListener(event, onEvent, true);
    };
  }, [
    event,
    savedHandler,
    useCapture
  ]);
}

function usePrevious(value) {
  let ref = React.useRef(value);
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

exports.getBreakpoint = getBreakpoint;
exports.useResponsive = useResponsive;
exports.eventTypeToJs = eventTypeToJs;
exports.useEventListenerOnDocument = useEventListenerOnDocument;
exports.usePrevious = usePrevious;
/* Utils Not a pure module */
